import { render, staticRenderFns } from "./AlsoItems.vue?vue&type=template&id=158adc0e&"
import script from "./AlsoItems.vue?vue&type=script&lang=js&"
export * from "./AlsoItems.vue?vue&type=script&lang=js&"
import style0 from "./AlsoItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports